import { Component, Inject, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatSnackBar } from '@angular/material/snack-bar';
import { BackendApi } from '../../services/backend-api';
import { Area } from '../../models/area';
import { UsageRate, UsageRateAreaCreate } from '../../models/usage-rate';
import {AsyncPipe} from '@angular/common';
import {MatAutocompleteModule} from '@angular/material/autocomplete';
import { map, Observable, startWith } from 'rxjs';

@Component({
  selector: 'app-create-usage-rate-area-dialog',
  imports: [MatDialogModule, MatInputModule, MatButtonModule, MatFormFieldModule, ReactiveFormsModule, MatSelectModule, MatAutocompleteModule, AsyncPipe],
  templateUrl: './create-usage-rate-area-dialog.html',
  styleUrl: './create-usage-rate-area-dialog.css',
})
export class CreateUsageRateAreaDialog {
  constructor(
    private readonly backendApi: BackendApi,
    private dialogRef: MatDialogRef<CreateUsageRateAreaDialog>,
    @Inject(MAT_DIALOG_DATA) public usageRate: UsageRate
  ) { }

  private _snackBar = inject(MatSnackBar);
  private _formBuilder = inject(FormBuilder);

  public areas!: Area[];
  public filteredAreas?: Observable<Area[]>;

  usageRateAreaForm = this._formBuilder.group({
    area: ['', Validators.required],
    price: [0.0000, Validators.required]
  });

  private _filterAreas(value: string) {
    return this.areas?.filter(area => this._normalize(area.country.name_fr).includes(this._normalize(value)));
  }

  private _normalize(str: string): string {
    return str.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
  }

  ngOnInit() {
    this.filteredAreas = this.usageRateAreaForm.get('area')?.valueChanges.pipe(
      startWith(''),
      map(value => this._filterAreas(value || ''))
    )

    this.backendApi.getAreas().subscribe({
      next: (areas) => {
        this.areas = areas;
      },
      error: () => {
        this._snackBar.open("Erreur rencontrée lors de la recuperation des areas.");
      }
    });
  }

  submit() {
    const usageRateArea: UsageRateAreaCreate = this.usageRateAreaForm.value as UsageRateAreaCreate;

    this.backendApi.createUsageRateArea(this.usageRate.uuid, usageRateArea).subscribe({
      next: (response) => {
        this._snackBar.open("Entrée ajoutée.");
        this.dialogRef.close(response);
      },
      error: () => {
        this._snackBar.open("Erreur rencontrée.");
      }
    })
  }
}
